; (function () {
    Date.prototype.format = function (fmt) {
        var o = {
            "M+": this.getMonth() + 1,     //月份
            "D+": this.getDate(),          //日
            "h+": this.getHours(),         //小时
            "m+": this.getMinutes(),       //分
            "s+": this.getSeconds()        //秒
        };
        if (/(Y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
        }
        for (var k in o) {
            if (new RegExp("(" + k + ")").test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
            }
        }
        return fmt;
    };

    String.prototype.ellipsis = function (n, ignore) {
        var reg = /[^\x00-\xff]/g;
        if (ignore) {
            if (this.length > n) {
                return this.substr(0, n) + '...';
            } else {
                return this;
            }
        }
        
        if (this.replace(reg, 'mm').length <= n) {
            return this;
        }
        var m = Math.floor(n / 2);
        for (var i = m; i < this.length; i++) {
            if (this.substr(0, i).replace(reg, 'mm').length >= n) {
                return this.substr(0, i) + '...';
            }
        }
        return this;
    };
    
    String.prototype.trim = function () {  
        return this.replace(/(^\s*)|(\s*$)/g, '');  
    };

    Array.prototype.insert = function(from, to){
        if (from>to) {
            this.splice(to, 0, this[from]);
            this.splice(from + 1, 1);
        } else {
            this.splice(to + 1, 0, this[from]);
            this.splice(from, 1);
        }
    };

    if (typeof exports === 'object') {
        module.exports = {};
    }
})();


//////////////////
// WEBPACK FOOTER
// ./static/1.0/js/page/dev/modules/prototype.js
// module id = 20
// module chunks = 1 2 3 5 6 7 8 9 10 11 12